import { createFileRoute } from "@tanstack/react-router";
import { AdminPlansPage } from "@/features/admin/plans";

export const Route = createFileRoute("/admin/plans")({
  head: () => ({ meta: [{ title: "Plans & limits · Admin · Malfak" }] }),
  component: AdminPlansPage,
});
